import { TextNode, EditorConfig, SerializedTextNode, $applyNodeReplacement, NodeKey } from 'lexical';

export class VariableNode extends TextNode
{
    static getType(): string
    {
        return 'variable';
    }

    static clone(node: VariableNode): VariableNode
    {
        return new VariableNode(node.__text, node.__pattern, node.__key);
    }

    __pattern: RegExp | undefined;

    constructor(text: string, pattern?: RegExp, key?: NodeKey)
    {
        super(text, key);
        this.__pattern = pattern;
    }

    createDOM(config: EditorConfig): HTMLElement
    {
        const element = super.createDOM(config);
        return element;
    }

    updateDOM(prevNode: VariableNode, dom: HTMLElement, config: EditorConfig): boolean
    {
        const base = super.updateDOM(prevNode as this, dom, config);
        if (this.__pattern == null) { dom.classList.add('editor-variable-invalid'); }
        else if (this.__pattern.test(this.getTextContent())) { dom.classList.remove('editor-variable-invalid'); }
        else { dom.classList.add('editor-variable-invalid'); }
        return base;
    }

    static importJSON(serializedNode: SerializedTextNode): VariableNode
    {
        const node = new VariableNode(serializedNode.text, new RegExp(''));
        node.updateFromJSON(serializedNode);
        return node;
    }

    exportJSON(): SerializedTextNode
    {
        const json = super.exportJSON();
        json.type = 'variable';
        return json;
    }
}

export function $createVariableNode(text: string, pattern?: RegExp): VariableNode
{
    const node = new VariableNode(text, pattern);
    return $applyNodeReplacement(node);
}
